import type { BrandVisibility } from '@/brand/types';

import * as routeNames from '@/constants/routeNames';

// https://github.com/vuetifyjs/vuetify/blob/master/packages/vuetify/src/composables/icons.tsx
export type IconValue = string | (string | [path: string, opacity: number])[];

export interface To {
  name: string;
}

export interface MenuListItem {
  title: string;
  icon?: IconValue;
  to?: To;
  staff?: boolean;
  subList?: MenuListItem[];
  disabled?: boolean;
  /** Which brand sees this item. Default is 'both'. */
  brand?: BrandVisibility;
}

export const accountList: readonly MenuListItem[] = [
  {
    title: 'Profile',
    icon: 'mdi-account-outline',
    to: { name: routeNames.PROFILE },
  },
  {
    title: 'Address Book',
    icon: 'mdi-book-open-page-variant-outline',
    to: { name: routeNames.ADDRESS_BOOK },
  },
  // {
  //   title: 'Settings',
  //   icon: 'mdi-cog-outline',
  // },
];

export const quoteSubList: readonly MenuListItem[] = [
  {
    title: 'New Quote',
    icon: 'mdi-email-edit-outline',
    to: { name: routeNames.NEW_QUOTE },
    disabled: true,
  },
  {
    title: 'List Quotes',
    icon: 'mdi-email-edit-outline',
    to: { name: routeNames.LIST_QUOTES },
    disabled: true,
  },
];

export const reportsSubList: readonly MenuListItem[] = [
  {
    title: 'ETA Report',
    icon: 'mdi-calendar-question-outline',
    to: { name: routeNames.ETA_REPORT },
  },
  {
    title: 'KPI Report',
    icon: 'mdi-chart-box-outline',
    to: { name: routeNames.KPI_REPORT },
    staff: true,
  },
  {
    title: 'Driver Report',
    icon: 'mdi-truck-outline',
    to: { name: routeNames.DRIVER_REPORT },
    staff: true,
  },
  {
    title: 'Tomorrow Report',
    icon: 'mdi-truck-outline',
    to: { name: routeNames.TOMORROW_REPORT },
    staff: true,
  },
  {
    title: 'Run Sheet',
    icon: 'mdi-truck-outline',
    to: { name: routeNames.RUN_SHEET },
    staff: true,
  },
  {
    title: 'Weekly Report',
    icon: 'mdi-calendar-question-outline',
    to: { name: routeNames.WEEKLY_STATS_REPORT },
    staff: true,
  },
  {
    title: 'AM/PM Jobs',
    icon: 'mdi-timetable',
    to: { name: routeNames.AM_PM_JOBS },
    staff: true,
  },
  {
    title: 'Download PODs Bulk',
    icon: 'mdi-folder-download-outline',
    to: { name: routeNames.REPORTS },
    staff: true,
    disabled: true,
  },
];

export const quoteTitle = 'Quote';
export const reportsTitle = 'Reports';
export const smsTitle = 'SMS';

export const smsSubList: MenuListItem[] = [
  {
    title: 'Daily follow-up',
    icon: 'mdi-message-bookmark-outline',
    to: { name: routeNames.SMS_DAILY_FOLLOW_UP },
  },
  {
    title: 'History',
    icon: 'mdi-message-text-clock-outline',
    to: { name: routeNames.SMS_HISTORY },
  },
  {
    title: 'Chat',
    icon: 'mdi-chat-outline',
    to: { name: routeNames.SMS_CHAT },
  },
];

export const mainList: readonly MenuListItem[] = [
  {
    title: 'Home',
    icon: 'mdi-home-variant-outline',
    to: { name: routeNames.HOME },
  },
  {
    title: 'Tracking',
    icon: 'mdi-truck-cargo-container',
    to: { name: routeNames.JOBS },
  },
  {
    title: 'Job booking',
    icon: 'mdi-file-document-plus-outline',
    to: { name: routeNames.JOB_BOOKING },
  },
  {
    title: 'Job tickets',
    icon: 'mdi-message-text-outline',
    to: { name: routeNames.JOB_TICKETS },
    staff: true,
  },
  {
    title: 'Search',
    icon: 'mdi-feature-search-outline',
    to: { name: routeNames.SEARCH },
  },
  {
    title: 'Dispatch',
    icon: 'mdi-receipt-text-clock-outline',
    to: { name: routeNames.DISPATCH },
    staff: true,
  },
  {
    title: 'Scheduler',
    icon: 'mdi-calendar-clock-outline',
    to: { name: routeNames.SCHEDULER },
    disabled: true,
  },
  {
    title: smsTitle,
    icon: 'mdi-message-text-outline',
    subList: smsSubList,
    staff: true,
  },
  {
    title: reportsTitle,
    icon: 'mdi-chart-box-outline',
    // TODO
    // @ts-expect-error
    subList: reportsSubList,
  },
  {
    title: 'TV',
    icon: 'mdi-television',
    to: { name: routeNames.JOBS_TV },
  },
  {
    title: 'BFIX Dash',
    icon: 'mdi-cards-outline',
    to: { name: routeNames.BFIX_DASH },
    staff: true,
    disabled: true,
  },
  {
    title: quoteTitle,
    icon: 'mdi-subtitles-outline',
    // TODO
    // @ts-expect-error
    subList: quoteSubList,
  },
  {
    title: 'Old Version',
    icon: 'mdi-open-in-app',
    to: { name: routeNames.OLD_VERSION },
    brand: 'kk',
  },
];

export const smsChatTemplateList: readonly MenuListItem[] = [
  {
    title: 'Your first job tomorrow at...',
  },
  {
    title: 'Your status now?',
  },
  {
    title: 'Check the App',
  },
  {
    title: 'Call manager',
  },
  {
    title: 'Where are you?',
  },
  {
    title: 'Please confirm delivery',
  },
  {
    title: 'Update your location',
  },
];
